/* eslint-disable camelcase */
import { handleActions } from 'redux-actions';
import { AppId } from '@piwikpro/apps-crate';
import {
  appInstallationCodeFetchInitialized,
  appInstallationCodeFetchSucceeded,
  appInstallationCodeFetchFailed,
} from '../ContainerSettings';

export interface AppInstallationCodeResponse {
  data: {
    id: AppId
    type: 'container/app/installation-code'
    attributes: {
      code: string
    }
  }
}

export interface AppInstallationCodeState {
  isLoading: boolean
  failed: boolean
  code: AppInstallationCodeResponse['data']['attributes']['code'] | null
}

const initialState: AppInstallationCodeState = {
  isLoading: true,
  failed: false,
  code: null,
};

export default handleActions<AppInstallationCodeState, AppInstallationCodeResponse>({
  [appInstallationCodeFetchInitialized.toString()]: () => initialState,
  [appInstallationCodeFetchSucceeded.toString()]: (
    state, { payload },
  ) => ({
    ...state,
    isLoading: false,
    code: payload.data.attributes.code,
  }),
  [appInstallationCodeFetchFailed.toString()]: state => ({
    ...state,
    isLoading: false,
    failed: true,
  }),
}, initialState);
